import { render } from "./UpdateEmailModal.vue?vue&type=template&id=7eadc120&ts=true"
import script from "./UpdateEmailModal.vue?vue&type=script&lang=ts"
export * from "./UpdateEmailModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__